<section class="vivascore-details clearfix flex flex-auto justify-between">
  <!---------------------------->
  <!-- Health Score Nudges:-->
  <!---------------------------->

  <ng-container *ngIf="healthData?.healthScoreNudges?.length; else noNudges">
    <section class="col col-12 md-col-5 viva-score-grey-border p1">
      <h3 class="caps center bold">Health Nudges</h3>
      <table>
        <tbody>
        <tr *ngFor="let healthScoreNudge of healthData?.healthScoreNudges">
          <td class="flex">
            <span>{{ healthScoreNudge?.name }}</span>
            <app-custom-tooltip [matTooltip]="healthScoreNudge?.message"
                                matTooltipPosition="above"></app-custom-tooltip>
          </td>
          <td>
            <app-updown-arrow [direction]="healthScoreNudge?.nudgeType"></app-updown-arrow>
          </td>
        </tr>
        </tbody>
      </table>
    </section>
  </ng-container>


  <!---------------------------->
  <!-- Biometric Data Section:-->
  <!---------------------------->

  <ng-container *ngIf="healthData?.biometricDataPoints?.length; else noBiometricDataPoints">
    <section class="col col-12 md-col-5 viva-score-grey-border p1">
      <h3 class="caps center-align bold">Data Points</h3>
      <table>
        <tbody>
        <tr *ngFor="let biometricData of healthData?.biometricDataPoints">
          <td class="flex">
            <span>{{ biometricData?.biometric }}</span>
            <app-custom-tooltip [matTooltip]="biometricData?.ruleText" matTooltipPosition="above"></app-custom-tooltip>
          </td>
          <td class="w-10"><b>{{ biometricData?.contributingPoints }}</b></td>
          <td>{{ biometricData?.resultDate | date: dateFormat }}</td>
          <td>
            <ng-container *ngIf="biometricData?.riskType; else noHeart">
              <app-heart [fillColor]="biometricData?.riskType"></app-heart>
            </ng-container>
            <ng-template #noHeart>-</ng-template>
          </td>
        </tr>
        </tbody>
      </table>
    </section>
  </ng-container>

  <!---------------------------->
  <!-- Empty PlaceHolders -->
  <!---------------------------->
  <ng-template #noNudges>
    <section class="col col-12 md-col-5 p2 viva-score-grey-border">
      <p class="center light-grey">There are no nudges available</p>
    </section>
  </ng-template>

  <ng-template #noBiometricDataPoints>
    <section class="col col-12 md-col-5 p2 viva-score-grey-border">
      <p class="center light-grey">There are no data points available</p>
    </section>
  </ng-template>
</section>
